import { useTranslation } from "react-i18next";
import { setLang } from "@/lib/i18n";
import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";

const langs = [
  { code: "ar", label: "العربية" },
  { code: "en", label: "English" },
  { code: "zh", label: "简体中文" },
];

export const LanguageSwitcher = () => {
  const { i18n } = useTranslation();
  return (
    <DropdownMenu>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon" aria-label="Change language" className="text-foreground hover:text-primary">
          <Globe className="h-5 w-5" aria-hidden="true" />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="glass-card">
        {langs.map((l) => (
          <DropdownMenuItem key={l.code} onClick={() => setLang(l.code)} className={i18n.language === l.code ? "text-primary" : ""}>
            {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
